import { useAlert } from 'components/alert'
import { useCallback } from 'react'

export interface UseHandleImpressaoErrorProps<E> {
  onError?: (error: E, errorMessage?: string) => void
}

export interface UseHandleImpressaoErrorResult<E> {
  handleImpressaoError: (error: E, errorMessage?: string) => void
}

const DEFAULT_MESSAGE = 'Não foi possível gerar a impressão. Tente imprimir novamente.'

export function useHandleImpressaoError<E = unknown>(
  props?: UseHandleImpressaoErrorProps<E>
): UseHandleImpressaoErrorResult<E> {
  const alert = useAlert()

  const handleImpressaoError = useCallback(
    (error: E, errorMessage?: string) => {
      alert('danger', errorMessage ?? DEFAULT_MESSAGE)
      props?.onError?.(error)
    },
    [alert, props]
  )

  return { handleImpressaoError }
}
